import { AlertButton, AlertStatic } from 'react-native';

// react-native's own AlertOptions interface isn't exported from its type
// defs, so the shape is inlined here -- only onDismiss matters on web.
type WebAlertOptions = { onDismiss?: () => void };

class WebAlert implements Pick<AlertStatic, 'alert'> {
  public alert(
    title: string,
    message?: string,
    buttons?: AlertButton[],
    options?: WebAlertOptions
  ): void {
    if (buttons === undefined || buttons.length === 0) {
      window.alert([title, message].filter(Boolean).join('\n'));
      // Copilot review, PR #5914: a plain window.alert() has no
      // confirm/cancel outcome to route through a button callback at all --
      // callers awaiting dismissal (e.g. waitForAlertDismissal) need
      // onDismiss to fire here too, or they hang forever on web.
      options?.onDismiss?.();
      return;
    }

    const result = window.confirm([title, message].filter(Boolean).join('\n'));

    if (result === true) {
      const confirm = buttons.find(({ style }) => style !== 'cancel');
      confirm?.onPress?.();
      return;
    }

    const cancel = buttons.find(({ style }) => style === 'cancel');
    if (cancel) {
      cancel.onPress?.();
      return;
    }
    // Copilot review, PR #5914: no cancel-style button was supplied (e.g. a
    // single-OK acknowledgment dialog) -- window.confirm's Cancel/Escape
    // outcome would otherwise call nothing at all, leaving a caller that
    // awaits dismissal (e.g. waitForAlertDismissal) hanging forever on web.
    options?.onDismiss?.();
  }
}

export const Alert = new WebAlert();
